const DEFAULT_LANGUAGE = 'en';

export default function getLanguageFromLocalStorage() {
  try {
    return window.localStorage.i18nextLng || DEFAULT_LANGUAGE;
  } catch (error) {
    return DEFAULT_LANGUAGE;
  }
}
